/* @flow */
import React, { memo } from 'react';
import styles from './ImageViewer.module.pcss';

type Props = {
  fileUrl: String,
};

const ImageViewer = ({ fileUrl }) => {
  return (
    <div>
      <img className={styles.imageContainer} alt="" src={fileUrl} />
    </div>
  );
};
const ImageViewerMemo = memo<Props>(ImageViewer);

export default ImageViewerMemo;
